import PropTypes from 'prop-types';
import Head from 'next/head';
import { map } from 'lodash';
import Layout from '../../ui/layout';
import fetchData from './fetchData';
import NewsItem from './news-item';
import { Wrap } from '../../styled';
import {
  NewsList,
  DescriptionContainer,
  H1,
  PrimaryDescription,
  SecondaryDescription,
} from './styled';

const Press = (props) => {
  const { collection, meta, title } = props;

  return (
    <Layout>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Wrap>
        <DescriptionContainer>
          <H1>Press</H1>
          <PrimaryDescription>
            Browse below for all the latest press coverage about EyeFitU.
          </PrimaryDescription>
          <SecondaryDescription>
            For interviews and other press related inquiries, please{' '}
            <a href="mailto:info@eyefitu.com">contact us</a>.
          </SecondaryDescription>
        </DescriptionContainer>
        <NewsList>
          {map(collection, ({ url, picture, description, text, id }) => (
            <NewsItem
              {...{
                key: id,
                picture,
                description,
                url,
                text,
              }}
            />
          ))}
        </NewsList>
      </Wrap>
    </Layout>
  );
};

Press.getInitialProps = async () => {
  const { page, collection } = await fetchData({ lang: 'en' });
  const { meta, title } = page;

  return {
    collection,
    meta,
    title,
  };
};

Press.propTypes = {
  collection: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default Press;
